import { Component, Input } from '@angular/core';

@Component({
  selector: 'loading-button',
  styleUrls: ['../styles/loading-button.scss'],
  template: `
    <button
      type="submit"
      [ngClass]="buttonClass"
      [class.user]="isUser"
      [class.m-progress]="isVisible"
      [class.disabled]="disabled"
      [class.responsive]="responsive"
      [class.keep-text]="isVisible && keepText"
      [disabled]="isVisible"
      [class.icon]="icon"
    >
      <span *ngIf="icon" class="material-icons">{{ icon }}</span>
      {{ !isVisible || keepText ? text : '' }}
    </button>
  `,
})
export class LoadingButtonComponent {
  @Input('is-visible') isVisible: boolean;
  @Input('is-user') isUser: boolean;
  @Input('text') text: string;
  @Input('disabled') disabled: string;
  @Input('responsive') responsive: boolean;
  @Input('buttonClass') buttonClass: string = 'loading-btn darkblue-gradient-bg';
  @Input('keep-text') keepText: boolean = false;
  @Input('icon') icon: string;
}
